export const SERVICES = [
  {
    num: '01',
    name: 'Identité\nVisuelle',
    desc: 'Logo, charte graphique, guideline de marque. Je crée des identités visuelles cohérentes et mémorables qui racontent votre histoire.',
    color: '#FF3B30',
  },
  {
    num: '02',
    name: 'Direction\nArtistique',
    desc: 'Stratégie visuelle globale, univers graphique, creative direction. Je pilote la vision créative de vos projets du concept à la production.',
    color: '#00D4FF',
  },
  {
    num: '03',
    name: 'UI / UX\nDesign',
    desc: 'Design d\'interfaces, design systems, prototypage interactif. Je crée des expériences digitales fluides et accessibles.',
    color: '#00E5A0',
  },
  {
    num: '04',
    name: 'Design\nPrint',
    desc: 'Brochures, packagings, kakémonos, affiches. Je donne forme à vos idées pour le monde physique avec rigueur et créativité.',
    color: '#FFD60A',
  },
];
